import { useState } from "react";
import dayjs from "dayjs";
import React from "react";

import JDate from "jalali-date";
import Container from "./index-css";
const Index = ({ data }) => {
  const [showMore1, setShowMore1] = useState(false);
  const [showMore2, setShowMore2] = useState(false);
  const [showMore3, setShowMore3] = useState(false);

  var arrPrice = [];
  var detail = JSON.parse(data.data[0].request_detail_json)
  try {
    arrPrice = JSON.parse(data.data[0].jsonpricing_text);
    if (arrPrice.instalment_conditions) {
      var cash = arrPrice.instalment_conditions.filter(
          (c) => c.instalment_conditions_mode_id === "0"
      );
      var check = arrPrice.instalment_conditions.filter(
          (c) =>
              c.instalment_conditions_mode_id === "1" ||
              c.instalment_conditions_mode_id === "3"
      );
    }
  } catch (e) {
    console.log(e);
  }

  let al = arrPrice.instalment_conditions;

  if (arrPrice.instalment_conditions) {
    al.sort(function (a, b) {
      // console.log("b: ", b)
      return (
          Number(a.instalment_conditions_date) -
          Number(b.instalment_conditions_date)
      );
    });
  }

  var date = dayjs(detail.request_thirdparty_last_date_sart);
  var startDate = new JDate(new Date(date.valueOf())).format("YYYY/MM/DD ");

  var date2 = dayjs(detail.request_thirdparty_last_date_end);
  var endDate = new JDate(new Date(date2.valueOf())).format("YYYY/MM/DD ");

  var active_star =
      parseInt(arrPrice.company_customer_satisfaction) +
      parseInt(arrPrice.company_levelof_prosperity) +
      parseInt(arrPrice.company_timeanswer_complaints);

  active_star = Math.ceil(active_star / 3 / 2);
  var deactive_star = 5 - active_star;

  const Stars = () => {
    var stars = [];
    for (var i = 0; i < active_star; i++) {
      stars.push(
          <img src="/imagess/star.png" key={i + deactive_star} alt="star icon" />
      );
    }
    return <>{stars}</>;
  };

  const Stars_ = () => {
    var dstars = [];
    for (var i = 0; i < deactive_star; i++) {
      dstars.push(<img src="/imagess/star_.png" key={i} alt="star icon" />);
    }
    return <>{dstars}</>;
  };

  function formatPrice(value) {
    return String(value).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  const handleClick = (id) => {
    if (id === 1) {
      setShowMore1(!showMore1);
    } else if (id === 2) {
      setShowMore2(!showMore2);
    } else if (id === 3) {
      setShowMore3(!showMore3);
    }
  };

  // *******************component************component*******************component*****************component*************

  const Text = (props) => {
    return (
        <Container>
          <div  className="main-textt">
            <div className="text-title">{props.title}:</div>
            <div className="text-detail">{props.detail}</div>
          </div>
        </Container>
    );
  };

  const Linetitle = (props) => {
    return (
        <Container>
          <div className="main-line">
            <div style={{ width: "100%" }} className="line">
              <div style={{ width: props.w }} className="line-text">
                {props.name}
              </div>
            </div>
          </div>
        </Container>
    );
  };
  return (
      <Container>
        <div className="main-map-detail">
          <div className="title">
            خلاصه سفارش بیـــمه
            <span
                style={{
                  color: "#1ad4a3",
                  marginRight: "5px",
                  display: "flex",
                }}
            >
         شخـص ثالــث
              </span>
          </div>
          <Linetitle name="اطلاعات خودرو" />
          <div className="map-detail-divv">
            <Text title="نوع خودرو" detail={detail.carmode_name} />
            <Text title="برند خودرو" detail={detail.car_company_name} />
            <Text title="مدل خودرو" detail={detail.car_name} />
            <Text
                title="سال ساخت"
                detail={detail.thirdparty_yearofcons_name}
            />
            <Text title="شرکت بیمه قبلی" detail={detail.thirdparty_lastcompany_name} />


            <Text title="تاریخ شروع بیمه‌نامه قبلی" detail={startDate} />
            <Text title="تاریخ اتمام بیمه‌نامه قبلی" detail={endDate} />
            <Text
                title="درصد تخفیف بیمه قبلی ثالث"
                detail={detail.thirdparty_discnt_thirdparty_name}
            />
            <Text
                title="درصد تخفیف بیمه قبلی راننده"
                detail={detail.thirdparty_discnt_driver_name}
            />


            <Text
                title="خسارت قبلی"
                detail={
                  parseInt(detail.thirdparty_damage_financial_id) &&
                  parseInt(detail.thirdparty_damage_driver_id) &&
                  parseInt(detail.thirdparty_damage_driver_id)
                      ? "فاقد خسارت"
                      : "دارای خسارت"
                }
            />
            <Text
                title="تعداد خسارت مالی"
                detail={detail.thirdparty_damage_financial_name}
            />
            <Text
                title="تعداد خسارت جانی"
                detail={detail.thirdparty_damage_human_name}
            />
            <Text
                title="تعداد خسارت حوادث راننده"
                detail={detail.thirdparty_damage_driver_name}
            />
          </div>

          <Linetitle name="پوشش های اضافی" />
          <div className="map-detail-divv">
            <Text
                title="مدت بیمه‌نامه"
                detail={detail.thirdparty_time_name}
            />
            <Text
                title="مورد استفاده"
                detail={detail.thirdparty_usefor_name}
            />
            <Text
                title="پوشش‌های بیمه‌نامه"
                detail={`${formatPrice(
                    detail.thirdparty_coverage_name
                )} `}
            />
          </div>

          <Linetitle name="اطلاعات بیمه" />
          <div className="map-detail-divv">
            <Text title="نام بیمه" detail={arrPrice.company_name} />
            <Text title="امتیاز بیمه" detail={arrPrice.company_levelof_prosperity} />
            <Text
                title="مبلغ بیمه"
                detail={`${formatPrice(arrPrice.price)} ریال`}
            />
            <Text
                title="درصد تخفیف مدیریتی"
                detail={
                  arrPrice.managdiscount_amount
                      ? `${arrPrice.managdiscount_amount} درصد`
                      : "ندارد"
                }
            />
            <Text title="پوشش‌ بیمه‌نامه" detail={`${formatPrice(detail.thirdparty_coverage_name)} `} />

            <Text
                title="امکان خرید اقساطی"
                detail={arrPrice.instalment_conditions ? "بله" : "خیر"}
            />
            <>
              {arrPrice.instalment_conditions && arrPrice.instalment_conditions.map((data) => (
                  <Text
                      title={data.instalment_conditions_desc}
                      detail={data.instalment_conditions_amount}
                  />
              ))}
            </>

          </div>
        </div>
      </Container>
  );
};

export default Index;
